// Sekce, kterou server v GET /ja nepovolil (08 §1 bod 1: menu jen zobrazuje, rozhoduje server).
// Vysvětlí proč a kam dál; položka v menu pro ni neexistuje.
import type { Ja } from '@ecoser/shared';
import { Link } from 'react-router';
import { popisekRole } from '../prihlaseni/nazvy';
import { nazevSekcePodleRole } from '../shell/menu';
import './sekce.css';

export function NematePristup({ klic, ja }: { klic: string; ja: Ja }) {
  const nazev = nazevSekcePodleRole(klic, ja);
  const role = popisekRole(ja.role_efektivni || ja.role);

  return (
    <section className="sekce" data-screen-label="Bez přístupu" data-sekce={klic}>
      <h1>Do této sekce nemáte přístup</h1>
      <p className="podtitul">Sekce {nazev}</p>
      <div className="hlaska hlaska--warn sekce__hlaska" role="status">
        <p>
          <strong>Proč:</strong>{' '}
          {role
            ? `sekce ${nazev} není pro roli ${role} povolená.`
            : 'účet zatím nemá přiřazenou roli, takže je k dispozici jen Domů.'}{' '}
          Co kdo vidí, určuje server podle role, příznaků a sekcí navíc na účtu (karta zaměstnance →
          Účet a oprávnění).
        </p>
        <p>
          <strong>Co dál:</strong> pokud sekci k práci potřebujete, požádejte správce aplikace o
          úpravu oprávnění. Do té doby použijte sekce v levém menu.
        </p>
      </div>
      <Link to="/" className="tlacitko tlacitko--primarni">
        Zpět na Domů
      </Link>
    </section>
  );
}
